import { FormControl, FormLabel, TextField } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { useForm } from "hooks/useForm";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editInput } from "redux/actions/formGenerator/formGeneratorActions";
import { addInput } from "redux/actions/formGenerator/formGeneratorActions";

export const ScriptFormInput = () => {
  const { inputSelect } = useSelector(
    ({ formGeneratorReducer }) => formGeneratorReducer
  );
  const { inputValues, handleInputOnChange, handleNewValues, cleanForm } = useForm({
    script: "",
  });
  const dispatch = useDispatch();
  const inputRef = useRef();

  const { script } = inputValues;

  useEffect(() => {
    const handleKeyPress = ({ key }) => {
      if (key === "Enter" && script.split(" ").length > 3) {
        if(Object.keys(inputSelect).length > 0){
          
          dispatch(editInput({
            ...inputSelect,
            script
          }))
          cleanForm()
        } else {
          dispatch(addInput(script));
          cleanForm()
        }
      }
    };

    if (inputRef.current) {
      inputRef.current.addEventListener("keypress", handleKeyPress);
    }

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener("keypress", handleKeyPress);
      }
    };
  }, [script]);

  useEffect(() => {
    Object.keys(inputSelect).length > 0 &&
      handleNewValues({ script: inputSelect.script });
  }, [inputSelect]);

  return (
    <FormControl fullWidth>
      <FormLabel style={{ marginBottom: 16 }}>Script form</FormLabel>
      <TextField
        size="small"
        label="Label -> name/value -> text/select -> cols -> true/false  "
        variant="outlined"
        name="script"
        value={script}
        onChange={handleInputOnChange}
        fullWidth
        align="center"
        inputRef={inputRef}
      />
      <code
        style={{
          backgroundColor: green[50],
          marginTop: 12,
        }}
      >
        Ejemplo: Unidad unit text 6 true
      </code>
    </FormControl>
  );
};
